/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useRef,
  createContext,
  useContext,
  useMemo,
} from 'react';
import { css, jsx } from '@emotion/core';
import Select from 'react-select';
import { colors } from 'styles/variables';
import setBlock from 'services/apiHelpers/setBlockProps';
import getMediaParent from 'services/apiHelpers/getMediaParent';
import { Block } from '@chameleoncreator/creator-app';
import getBlockById from 'services/apiHelpers/getBlockById';
import setBlockProps from 'services/apiHelpers/setBlockProps';
import SetMediaType from 'components/Editor/SetMediaType';
import ImageLibrary from './ImageLibrary';
import EditorBtn from 'components/UI/EditorBtn';
import getStore from 'services/getStore';
// updated UI
import { H1 as H1_v2, H2 as H2_v2 } from '../EditorUtilities/UI/Headings';
import NumberPicker_v2 from '../EditorUtilities/UI/NumberPicker';
import Info from '../EditorUtilities/UI/Info';
import {
  isFeatureEnabled,
  FeatureFlag,
} from '../../../services/isFeatureEnabled';
import helpers from 'components/lib/EditableText/LinkModal/helpers';
import getLocationName from 'services/getLocationName';
import { NavigationSettings } from 'components/NavigationSettings/NavigationSettings_v2';
import { NavigationSettingsButton } from 'components/NavigationSettings/NavigationSettingsButton';
import { NavigationWidget } from 'components/NavigationSettings/NavigationWidget';
import CheckBox_v2 from '../EditorUtilities/UI/CheckBox';
import ColorPicker_v2 from '../EditorUtilities/UI/ColorPicker';

import { PreviewInfo } from './ImageLibrary/YourLibrary/YourImagePreviewPanel';

interface IImageLibraryContext {
  currentImageSrc: string;
  currentImageId: string | number;
  onAddImage?: ({}: any) => void;
  onClose?: () => void;
  cacheSelected?: { [key: string]: any };
  cacheFilter?: { [key: string]: any };
}

const ImageLibraryContext = createContext<IImageLibraryContext | undefined>(
  undefined
);

const { lGrey0, lGrey1, mint } = colors;

const { getState } = getStore();

function getImgName(src) {
  let name: any = src.split(/\//g);
  name = name[name.length - 1];

  return name;
}
const Panel = ({ title, info, children, ...props }) => {
  return (
    <div
      css={css`
        margin: 20px 0 0 0;
      `}
      {...props}
    >
      <div
        css={css`
          margin: 0 0 5px 0;
        `}
      >
        {!info ? <H2_v2>{title}</H2_v2> : <Info info={info}>{title}</Info>}
      </div>
      {children}
    </div>
  );
};

const Input = ({ defaultValue, update }) => {
  return (
    <input
      type="text"
      defaultValue={defaultValue}
      css={css`
        width: 100%;
        margin: 0 0 10px 0;
        padding: 10px;
        border: 1px solid ${lGrey1};
        outline: none;
        resize: none;
        font-family: 'Poppins';
        font-size: 12px;
      `}
      onKeyUp={e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          update(e.currentTarget.value);
        }
      }}
      onBlur={e => {
        e.preventDefault();
        update(e.currentTarget.value);
      }}
    />
  );
};

const ImageLibraryBtn = ({ imageLibrary, setImageLibrary }) => {
  return (
    <EditorBtn
      label="Insert image"
      style={{
        flexShrink: 0,
        width: `${'175px' || '100%'}`,
        border: `1px solid ${lGrey0}`,
        background: '#fff',
        color: lGrey0,
        fontSize: 11,
        hover: {
          color: '#fff',
          background: '#28292b',
        },
      }}
      css={css`
        min-height: 30px;
      `}
      onClick={() => {
        setImageLibrary(!imageLibrary);
      }}
    />
  );
};

const currentLink = (() => {
  let $;
  return link => {
    return link || link === null ? ($ = link) : $;
  };
})();

const EditImage = ({ block, type = null }) => {
  const [imageLibrary, setImageLibrary] = useState(false);
  const [assetLibrary, setAssetLibrary] = useState(false);

  const description = useRef(null);

  const properties = {
    src: undefined,
    imageId: '',
    size: 0,
    borderStyle: 'rectangle',
    fit: 'fill',
    fixedHeight: false,
    fixedHeightValue: 350,
    maxHeight: 50,
    imgSize: 0,
    description: '',
    imageZoom: false,
    imageZoomBackgroundColor: '#fff',
    fullHeight: false,
    defaultHeight: true,
    imageHeight: undefined,
    ...block.props,
  };

  const {
    id,
    src,
    imageId,
    size,
    borderStyle,
    fit,
    // fixedHeight,
    // fixedHeightValue,
    // maxHeight,
    imgSize,
    imgContainerHeight = 0,
    imgMagnification = 100,
    description: desc,
    imageZoom,
    imageZoomIconColor,
    imageZoomBackgroundColor,
    // href,
    // hrefInfo,
    linkData = {
      url: '',
      title: '',
      target: '',
    },
    // fullHeight,
    // imageHeight,
    // defaultHeight,
  } = properties;

  // const [showNavigationModal, setShowNavigationModal] = useState(false);
  const [modal, showModal] = useState(false);
  // const [showModuleNavigation, setShowModuleNavigation] = useState(false);

  const { getCurrentLinkAttribute, getValue } = helpers(
    {},
    () => {},
    linkData,
    value => {
      console.log(value);
    }
  );

  const isTextAndImage = useMemo(() => {
    const currentInteractionBlock: any = getBlockById(
      getState().currentInteraction
    );
    return currentInteractionBlock?.meta.subType === 'TextAndImage';
  }, []);

  const moduleFrame = useMemo(() => frames[0], []);
  let imageContainerHeightPermission;

  if (moduleFrame && moduleFrame?.location?.href?.includes('module.html')) {
    const section = moduleFrame.document.querySelector('section');
    //
    const interactionBlock =
      section?.id && (getBlockById(section?.id.replace('i', '')) as any);

    const canUpdateContainerHeight = section
      ?.querySelector(`#chameleon-image-${block.id}`)
      ?.getAttribute('data-can-update-container-height');

    imageContainerHeightPermission = canUpdateContainerHeight === 'true';

    const modalContainer = moduleFrame?.document.querySelector(
      `#modal-container`
    );

    if (modalContainer) {
      const imgElement = moduleFrame?.document.querySelector(
        `#img-${block.id}`
      );
      if (imgElement && modalContainer.contains(imgElement)) {
        imageContainerHeightPermission = true;
      }
      //
    }
  }

  let location = linkData?.url || block.props.location;

  let locationName: string[] | string | undefined = getLocationName(
    linkData.url
  );

  if (linkData.target === '_blank') {
    locationName = linkData.url;
  }

  if (locationName && Array.isArray(locationName)) {
    locationName = locationName.join('/');
  }

  const localModeImageUpload = [
    'http://localhost:3011/',
    'http://reviewsite.inspiregroup.co.nz',
  ].some(entry => window.location.href.match(entry));

  const Option = key => ({ innerRef, innerProps, ...props }) => {
    const { value, label } = props;

    return (
      <div
        ref={innerRef}
        {...innerProps}
        css={css`
          display: flex;
          align-items: center;
          height: 35px;
          padding: 0 10px;
          font-size: 12px;
          font-weight: ${properties[key] === value ? 500 : 200};
          cursor: pointer;
          pointer-events: ${properties[key] === value ? 'none' : 'auto'};
          &:hover {
            background: #deebff;
          }
        `}
        onClick={e => {
          setBlock(block, { [key]: value });
        }}
      >
        {label}
      </div>
    );
  };

  const borderStyles = {
    circle: 'Circle',
    rectangle: 'Rectangle',
    roundedRectangle: 'Rounded rectangle',
  };

  const fits = {
    fill: 'Fill',
    contain: 'Contain',
    cover: 'Cover',
  };

  if (type && type === 'logo') {
    return (
      <div
        css={css`
          margin: 20px 0;
        `}
      >
        <ImageLibraryBtn
          imageLibrary={imageLibrary}
          setImageLibrary={setImageLibrary}
        />
        <Panel
          title="Image description"
          info="Give your image a description for screen readers."
          css={css`
            font-size: 12px;
          `}
        >
          <Input
            defaultValue={desc}
            update={value => {
              setBlock(block, { description: value });
            }}
          />
        </Panel>

        {imageLibrary && (
          <ImageLibraryContext.Provider
            value={{
              onAddImage(result) {
                setBlock(block, { src: result.url, imageId: result.id });
              },
              onClose() {
                setImageLibrary(!imageLibrary);
              },
              currentImageSrc: src,
              currentImageId: imageId,
              cacheSelected: {
                yourLibrary: null,
                chameleonsLibrary: 0,
              },
              cacheFilter: {
                value: '',
              },
            }}
          >
            <ImageLibrary />
          </ImageLibraryContext.Provider>
        )}
      </div>
    );
  }

  return (
    <div>
      <SetMediaType block={block} mediaParent={getMediaParent(block.id)} />

      <Panel
        title="Image sizing guide"
        info={
          <div
            css={css({
              span: {
                fontWeight: 500,
              },
            })}
          >
            <div
              style={{
                fontWeight: 500,
                margin: '0 0 10px 0',
              }}
            >
              Max widths for:
            </div>
            <div>
              Single Column <span>- 1100px</span>
            </div>
            <div>
              Two Column <span>- 1100px</span>
            </div>
            <div>
              Full screen Width <span>- 1920px</span>
            </div>
            <div>
              Background Image <span>- 1920px</span>
            </div>
            <div
              style={{
                margin: '10px 0 0 0',
              }}
            >
              Aim to keep file size below 1.5mb
            </div>
          </div>
        }
        css={css`
          font-size: 12px;
        `}
      >
        {!localModeImageUpload ? (
          <ImageLibraryBtn
            imageLibrary={imageLibrary}
            setImageLibrary={setImageLibrary}
          />
        ) : (
          <div
            style={{
              width: 'calc(100% - 0px)',
            }}
          >
            <Input
              defaultValue={desc}
              update={value => {
                console.log({ src: value });

                setBlock(block, { src: value || undefined });
              }}
            />
          </div>
        )}

        {/* <ImgSrcLabel src={src} /> */}

        {src && (
          <div style={{ margin: '10px 0 0 0' }}>
            <PreviewInfo property="Name" value={getImgName(src)} />
            {!!size && <PreviewInfo property="Size" value={size} />}
          </div>
        )}
      </Panel>

      <Panel
        title="Shape"
        info="Set the border shape of your image."
        css={css`
          font-size: 12px;
        `}
      >
        <Select
          key={borderStyle}
          placeholder={borderStyles[borderStyle] || 'Select'}
          options={Object.keys(borderStyles).map((e, i) => ({
            value: e,
            label: borderStyles[e],
          }))}
          components={{ Option: Option('borderStyle') }}
        />
      </Panel>

      <Panel
        title="Image fit"
        info="Set the position of the image within the frame."
        css={css`
          font-size: 12px;
        `}
      >
        <Select
          key={fit}
          placeholder={fits[fit] || 'Select'}
          options={Object.keys(fits).map((e, i) => ({
            value: e,
            label: fits[e],
          }))}
          components={{ Option: Option('fit') }}
        />
      </Panel>

      {imageContainerHeightPermission && (
        <_>
          <Panel
            title="Image container height"
            info="Increase the size of your image by controlling the height of its container."
            css={css`
              font-size: 12px;
            `}
          >
            <NumberPicker_v2
              label="Value"
              value={imgContainerHeight}
              min={-1000000}
              increment={5}
              onChange={value => {
                setBlockProps(block, { imgContainerHeight: value });
              }}
            />
          </Panel>
        </_>
      )}

      <_>
        <Panel
          title="Image magnification"
          info="Display a magnified version of your image within its container. Values can be positive or negative."
          css={css`
            font-size: 12px;
          `}
        >
          <NumberPicker_v2
            label="Value"
            value={imgMagnification}
            min={0}
            increment={5}
            onChange={value => {
              setBlockProps(block, { imgMagnification: value });
            }}
          />
        </Panel>
      </_>

      {!(1 === 1) && isTextAndImage && (
        <_>
          <Panel
            title="Image size"
            info="Increase the default size of your image by the selected value."
            css={css`
              font-size: 12px;
            `}
          >
            <NumberPicker_v2
              label="Value"
              value={imgSize}
              increment={5}
              onChange={value => {
                setBlockProps(block, { imgSize: value });
              }}
            />
          </Panel>
        </_>
      )}

      <Panel
        title="Image description"
        info="Give your image a description for screen readers."
        css={css`
          font-size: 12px;
        `}
      >
        <Input
          defaultValue={desc}
          update={value => {
            setBlock(block, { description: value });
          }}
        />
      </Panel>

      <div>
        <CheckBox_v2
          label="Include image zoom"
          on={imageZoom}
          onClick={() =>
            setBlockProps(block, {
              imageZoom: !imageZoom,
            })
          }
        />
      </div>

      {imageZoom && (
        <div
          css={css`
            margin-top: 10px;
          `}
        >
          <div
            style={{
              margin: '0 0 10px 0',
            }}
          >
            <ColorPicker_v2
              inColor={imageZoomIconColor}
              outColor={color =>
                setBlockProps(block, { imageZoomIconColor: color })
              }
              label="Icon colour"
            />
          </div>

          <ColorPicker_v2
            inColor={imageZoomBackgroundColor}
            outColor={color =>
              setBlockProps(block, { imageZoomBackgroundColor: color })
            }
            label="Background colour"
          />
        </div>
      )}

      {isFeatureEnabled(FeatureFlag.AddESVGImage) && (
        <_>
          {imageLibrary && (
            <ImageLibraryContext.Provider
              value={{
                onAddImage(result) {
                  const { url, id, width, height, size } = result;

                  console.log({ url, id, width, height, size });

                  setBlock(block, {
                    src: url,
                    imageId: id,
                    width,
                    height,
                    size,
                  });
                },
                onClose() {
                  setImageLibrary(!imageLibrary);
                },
                currentImageSrc: src,
                currentImageId: imageId,
                cacheSelected: {
                  yourLibrary: null,
                  chameleonsLibrary: 0,
                },
                cacheFilter: {
                  value: '',
                },
              }}
            >
              <ImageLibrary />
            </ImageLibraryContext.Provider>
          )}

          {isTextAndImage && (
            <div style={{ margin: '15px 0 0 0', fontSize: 12 }}>
              <div
                style={{
                  margin: '20px 0 10px 0',
                  fontWeight: 500,
                }}
              >
                <Info info="Click Navigation to link your image to a location within the module or an external url.">
                  IMAGE NAVIGATION
                </Info>
              </div>

              <NavigationWidget
                showModal={showModal}
                linkData={linkData}
                locationName={locationName}
              />
            </div>
          )}

          {modal && (
            <div>
              <NavigationSettings
                linkData={linkData}
                tab={linkData?.target === '_blank' ? 'external' : 'module'}
                onClose={() => showModal(false)}
              >
                {(localLinkData, updateLocalLinkData, currentTab) => {
                  let label = 'Save and close';

                  return (
                    <div>
                      <div
                        css={css({
                          display: 'flex',
                        })}
                      >
                        <NavigationSettingsButton
                          label="Cancel"
                          onClick={() => {
                            showModal(false);
                          }}
                        />

                        <NavigationSettingsButton
                          label={label}
                          enabled={true}
                          style={{
                            background: mint,
                            color: '#fff',
                            boxShadow:
                              '-16px -16px 27px rgba(255, 255, 255, 0.5), 16px 16px 27px rgba(37, 59, 176, 0.14393)',
                          }}
                          onClick={() => {
                            setBlockProps(block, {
                              linkData: {
                                ...linkData,
                                ...localLinkData,
                                ...(location && {
                                  location: null,
                                }),
                              },
                            });

                            showModal(false);
                          }}
                        />
                      </div>
                      <div
                        css={css({
                          margin: '15px 0 0 0',
                          fontSize: 14,
                          color: '#98add9',
                          textDecoration: 'underline',
                          textAlign: 'center',
                          cursor: 'pointer',

                          ':hover': {
                            opacity: 0.8,
                          },
                        })}
                        onClick={() => {
                          setBlockProps(block, {
                            linkData: {
                              url: '',
                              title: '',
                              target: '',
                            },
                          });

                          showModal(false);
                        }}
                      >
                        Remove link
                      </div>
                    </div>
                  );
                }}
              </NavigationSettings>
            </div>
          )}
        </_>
      )}
    </div>
  );
};

export default EditImage;
export { ImageLibraryContext };
